const IS_PROD = process.env.NODE_ENV === 'production';
const PROD_DOMAIN = 'epn.bz';
const YANDEX_METRIKA_SCRIPT_ID = 'epn-yandex-metrika-script';

declare global {
    interface Window {
        ym?: (...args: unknown[]) => void;
        epnYmInitialized?: boolean;
    }
}

export const initEpnBaseMetric = (): void => {
    if (typeof window === 'undefined') return;
    if (window.epnYmInitialized) return;
    if (!IS_PROD || window.location.host !== PROD_DOMAIN) return;

    const ymStub =
        window.ym ||
        ((...args: unknown[]) => {
            ((ymStub as typeof ymStub & { a?: unknown[][] }).a =
                (ymStub as typeof ymStub & { a?: unknown[][] }).a || []).push(args);
        });

    (ymStub as typeof ymStub & { l?: number }).l = Date.now();
    window.ym = ymStub;

    if (!document.getElementById(YANDEX_METRIKA_SCRIPT_ID)) {
        const script = document.createElement('script');
        const [firstScript] = document.getElementsByTagName('script');

        script.async = true;
        script.src = 'https://mc.yandex.ru/metrika/tag.js';
        script.id = YANDEX_METRIKA_SCRIPT_ID;
        firstScript?.parentNode?.insertBefore(script, firstScript);
    }

    window.ym?.(89120816, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    });
    window.ym?.(32852492, 'init', {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
    });

    window.epnYmInitialized = true;
};

export const EpnBaseMetricHead: React.FC = () => {
    return (
        <>
            {/* <!-- Facebook Pixel --> */}
            <meta name="facebook-domain-verification" content="f0v5ktt5b6s4gusatmcnhgfov4i17v" />
            {/* !<-- END Facebook pixel --> */}
        </>
    );
};

export const EpnBaseMetricBody: React.FC = () => null;
